import request from '@/utils/request_login';
import { transformRequest } from '@/utils/request_config';

// 获取个人信息
export const getUserApi = () => request({
  url: `/authentication/oauth/getUser`,
  method: 'get',
});
// 设置语言code到缓存
export const getSetLanguageCodeToCacheApi = (languageCode: string) => request({
  url: `/issue/student/getSetLanguageCodeToCache/?languageCode=${languageCode}`,
  method: 'get',
});
// 新架构登录接口
export const loginApi = (params: any) => request({
  url: '/authentication/oauth/token',
  method: 'post',
  params,
  // 定义对于给定的HTTP 响应状态码是 resolve 或 reject  promise 。
  // 如果 `validateStatus` 返回 `true` (或者设置为 `null` 或 `undefined`)，promise 将被 resolve; 否则，promise 将被 rejecte
  // validateStatus(status) {
  //   return status >= 200 && status < 500
  // }
});
// 新架构刷新token
export const refreshTokenApi = (refreshToken: any) => request({
  url: '/authentication/oauth/token',
  method: 'post',
  data: {
    grant_type: 'refresh_token',
    refresh_token: refreshToken,
  },
  transformRequest
});

// 登出
export const logoutApi = () => request({
  url: '/authentication/oauth/logout',
  method: 'get',
});

// 注册
export const gearRegisterApi = (data: any) => request({
  url: '/appUser/gearRegister',
  method: 'post',
  data
})

// 修改密码
export const gearModifyPwdApi = (data: any) => request({
  url: '/appUser/gearModifyPwd',
  method: 'post',
  data
})

// 获取手机验证码
export const getVerificationCodeApi = (data: { email: string, type: string }) => request({
  url: '/appUser/verification',
  method: 'post',
  data: Object.assign(data, { fkPlatformType: 'get_issue' })
})

// 手机区号
export const getPhoneRegionApi = () => request({
  url: '/issue/studentCountry/getPhoneRegion',
  method: 'get',
})

// 国家
export const getAllAreaCountryListApi = () => request({
  url: '/appInstitution/areaCountry/getAllAreaCountryList',
  method: 'get',
})

// 州省
export const getByCountryIdApi = (id: number) => request({
  url: `/appInstitution/areaState/getByCountryId/${id}`,
  method: 'get',
})

// 城市
export const getByFkAreaStateIdApi = (id: number) => request({
  url: `/appInstitution/areaCity/getByFkAreaStateId/${id}`,
  method: 'get',
})

// 获取issue模块权限
export const getIssueRootApi = () => request({
  url: '/issue/summary/getIssueRoot',
  method: 'get'
})
// 重置密码
export const updatePwdByIssueApi = (data: any) => request({
  url: '/appUser/updatePwdByIssue',
  method: 'post',
  data
})

// 发送邮箱验证码
export const sendEmailCodeApi = (email: string) => request({
  url: '/appUser/sendEmailCode',
  method: 'get',
  params: { email }
})
// 验证邮箱验证码
export const verifyEmailCodeApi = (email: string, code: string) => request({
  url: '/appUser/verifyEmailCode',
  method: 'get',
  params: { email, code }
})
// 携带邮箱验证码+新密码密码，进行修改密码
export const modifyPwdByEmailCodeApi = (params: { email: string, code: string, newPWD: string }) => request({
  url: '/appUser/modifyPwdByEmailCode',
  method: 'get',
  params
})
